var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal",
    {
      attrs: {
        title: _vm.$t("expiredInventory.businessOrders.title"),
        config: { focusFirst: false, closeToClick: false },
        "show-close": false
      }
    },
    [
      _c(
        "template",
        { slot: "titleTooltip" },
        [
          _c("button-tooltip", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.bottom",
                value: {
                  content: _vm.$t("expiredInventory.businessOrders.tooltip"),
                  delay: { show: 500, hide: 300 }
                },
                expression:
                  "{\n            content: $t('expiredInventory.businessOrders.tooltip'),\n            delay: { show: 500, hide: 300 },\n        }",
                modifiers: { bottom: true }
              }
            ]
          })
        ],
        1
      ),
      _c("expired-lot-business-order-create-form", {
        ref: "form",
        attrs: {
          "is-smart-freight-selected": _vm.isSmartFreightSelected,
          "business-order": _vm.modalData.businessOrder,
          "expired-items": _vm.modalData.expiredItems,
          warehouses: _vm.modalData.warehouses
        },
        on: {
          save: _vm.save,
          cancel: function($event) {
            return _vm.$emit("close")
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }